
import { CardContainer } from "./card.styled";
import { CardProps } from "./card.props";
import { useState } from "react";

const Card: React.FC<CardProps> = ({ borderRadius, style, ...props }) => {
    return <CardContainer style={{
        ...style,
        borderRadius: borderRadius === false ? "0" : "10px",
    }}  {...props} />
};

export const CardCustom: React.FC<CardProps> = ({ title, content, hasToggle = true, ...props }) => {
    const [isOpen, setIsOpen] = useState(hasToggle ? false : true); // Mặc định mở nếu không có toggle
    return (
        <div className="max-w-md mx-auto border border-gray-300 shadow rounded-lg overflow-hidden">
            <div className="p-4 bg-gray-100 flex justify-between items-center">
                <h2 className="text-lg font-semibold">{title}</h2>
                {hasToggle && (
                    <button
                        className="text-gray-500 hover:text-gray-800"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        {isOpen ? "▲" : "▼"}
                    </button>
                )}
            </div>
            {isOpen && (
                <div className="p-4 bg-white">
                    {props.children}
                </div>
            )}
        </div>
    );
};

export default Card;
